import NextImage from "next/image";
import React, { useState } from "react";
import { FaImages, FaPlus, FaTrash } from "react-icons/fa";
import ImageZoom from "../Posts/ImageZoom";

interface Image {
  id: string;
  file: File;
}

interface ImageUploadWithPreviewProps {
  [key: string]: any;
}

const ImageUploadWithPreview: React.FC<ImageUploadWithPreviewProps> = (props) => {
  const [image, setImage] = useState<Image | null>({
    id: props?.existingImage || "",
    file: new File([], ""),
  });

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files?.[0] : null;
    if (file) {
      setImage({
        id: URL.createObjectURL(file),
        file: file,
      });
      if (props.onChange) {
        props.onChange(file);
      }
    }
  };

  const handleRemoveImage = () => {
    if (image) {
      props.onRemove?.(image.file);
      URL.revokeObjectURL(image.id);
      setImage(null);
    }
  };

  return (
    <div className="my-3 flex">
      <div className="relative flex flex-wrap">
        {image?.id && (
          <div>
            <ImageZoom>
              <NextImage
                src={image.id}
                width={80}
                height={80}
                alt="Preview"
                className="rounded-lg object-cover shadow-lg"
              />
            </ImageZoom>
            <button
              onClick={handleRemoveImage}
              className="absolute right-0 top-0 rounded-full p-1 text-white"
              aria-label="Delete Image"
            >
              <FaTrash size={16} />
            </button>
          </div>
        )}
      </div>
      {!image?.id && (
        <div className="relative">
          <input
            {...props}
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="absolute z-10 h-full w-full cursor-pointer opacity-0"
          />
          <label className="bg-base-100 flex h-20 w-20 cursor-pointer items-center justify-center rounded-md border-2 border-gray-500">
            <FaImages size={48} />
            <div className="bg-base-300 absolute h-20 w-20 opacity-80"></div>
            <div className="absolute flex h-12 w-12 items-center justify-center text-gray-500 hover:text-gray-300">
              <FaPlus size={24} />
            </div>
          </label>
        </div>
      )}
    </div>
  );
};

export default ImageUploadWithPreview;
